import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from 'src/app/core/services/nav/nav.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit {

  constructor(
    private navService: NavService,
    private router: Router
  ) { }

  ngOnInit(): void {
    Promise.resolve().then(() => this.navService.setTitle('Acesso Negado'))
  }

  goToAuth() {
    this.router.navigate(['/auth']);
  }
}
